import { EntityLookup, supplierSource } from "@/components/lookup";

/** Fornecedor por código, nome, nome fantasia ou CPF/CNPJ (digitação + lupa). */
export function SupplierPicker({
  value,
  label,
  onChange,
  disabled,
}: {
  value: string;
  label: string;
  onChange: (id: string, label: string) => void;
  disabled?: boolean;
}) {
  return (
    <EntityLookup
      source={supplierSource}
      value={value}
      label={label}
      onChange={onChange}
      {...(disabled !== undefined ? { disabled } : {})}
    />
  );
}
